import { Attention, Conseil, Info } from '@/design-system'

import { ExempleCalcul } from './ExempleCalcul'
import { TableauSeuils } from './TableauSeuils'

export const metadata = {
	title: 'Le régime micro-BIC',
	description: 'Comprenez le régime fiscal simplifié pour les petits loueurs en meublé.'
}

# Le régime micro-BIC

Le régime micro-BIC (Bénéfices Industriels et Commerciaux) est un régime fiscal simplifié pour les loueurs en meublé dont les recettes ne dépassent pas certains plafonds.

## Plafonds de recettes

<TableauSeuils />

<Attention>
Au-delà de ces plafonds, vous basculez automatiquement au régime réel d'imposition.
</Attention>

## Avantages du régime

- **Simplicité** : Pas de comptabilité complexe à tenir
- **Déclaration simplifiée** : Une simple déclaration de recettes suffit
- **Abattement automatique** : Les charges sont déduites forfaitairement

<ExempleCalcul />

## Obligations comptables

- Tenir un livre de recettes
- Conserver les justificatifs pendant 6 ans
- Déclarer les recettes brutes annuelles

<Conseil>
Utilisez un logiciel de gestion locative ou un simple tableur pour suivre vos recettes tout au long de l'année.
</Conseil>

## Passage au régime réel

Le passage au régime réel est :

### Obligatoire si :
- Dépassement des plafonds de recettes
- Activité exercée dans le cadre d'une société

### Optionnel si :
- Vos charges réelles dépassent l'abattement forfaitaire
- Vous souhaitez reporter un déficit
- Vous voulez récupérer la TVA sur les travaux

<Info>
L'option pour le régime réel est valable 2 ans minimum et se reconduit tacitement par période de 2 ans.
</Info>
